import CategoryService from "@/services/api/category";
import type { GetCategoryResponse, CategoryParams, Category } from "@/types/category";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface CategoryState {
  categories: Category[];
  totalRecords: number;
  isFetching: boolean;
}

const name = "category";

const initialState: CategoryState = {
  categories: [],
  totalRecords: 0,
  isFetching: false,
};

// Async thunk for getting categories
export const getCategories = createAsyncThunk<
  GetCategoryResponse,
  CategoryParams | undefined,
  { rejectValue: string }
>(`${name}/getCategories`, async (params, { rejectWithValue }) => {
  try {
    const data: GetCategoryResponse = await CategoryService.getAllCategories(params);
    return data ?? { totalRecord: 0, results: [] };
  } catch (err) {
    const error = err as { message?: string };
    return rejectWithValue(error.message ?? "Failed to fetch categories");
  }
});

const categorySlice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCategories.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(
        getCategories.fulfilled,
        (state, action: PayloadAction<GetCategoryResponse>) => {
          state.isFetching = false;
          state.categories = action.payload.results;
          state.totalRecords = action.payload.totalRecord;
        },
      )
      .addCase(getCategories.rejected, (state, action) => {
        state.isFetching = false;
        console.error("Failed to fetch categories:", action.payload);
      });
  },
});

export default categorySlice.reducer;
export const { clear } = categorySlice.actions;
export type { CategoryState };
